import { lazy } from 'react';
const RootLayout = lazy(() => import('./layout'));
const SystemsTable = lazy(() => import('./home/page'));
const ScanPage = lazy(() => import('./scans/[id]/page'));
const LoginProvider = lazy(() => import('./components/LoginProvider'));
const Logout = lazy(() => import('./logout/page'));
import ErrorBoundaries from './components/ErrorBoundaries';
import LandingRedirect from './components/LandingRedirect';

/**
 * declarative react-router routes
 */
const routes = [
  //Public routes (no Loginprovider)
  {
    Component: Logout,
    path: 'logout'
  },
  {
    path: '/',
    Component: LoginProvider,
    ErrorBoundary: ErrorBoundaries,
    children: [
      {
        Component: RootLayout,
        ErrorBoundary: ErrorBoundaries,
        children: [
          { path: '/', Component: LandingRedirect },
          { path: '/projects', index: true, Component: SystemsTable },
          {
            path: 'projects/:id/',
            ErrorBoundary: ErrorBoundaries,
            children: [
              { index: true, Component: ScanPage },
              {
                path: 'scan/:scanid/',
                children: [
                  { path: 'objectives', Component: ScanPage },
                  {
                    path: 'overview/',
                    children: [
                      { path: 'checklist-guide', Component: ScanPage },
                      { path: 'add-considerations', Component: ScanPage }
                    ]
                  },
                  {
                    path: 'scan-data/',
                    children: [
                      { path: 'business', Component: ScanPage },
                      { path: 'data', Component: ScanPage },
                      { path: 'time-based', Component: ScanPage },
                      { path: 'users', Component: ScanPage },
                      { path: 'technical', Component: ScanPage },
                      { path: 's4', Component: ScanPage },
                      { path: 'add-ons', Component: ScanPage }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  // public (unauthenticated) routes
  {
    path: '/logout',
    Component: Logout
  }
];

export default routes;
